import {FlashService} from "../../flash/flash-service";
import {inject} from "aurelia-framework";
import {NotificationActionbox} from "./notification-actionbox";

@inject(FlashService)
export class NotificationCallbox extends NotificationActionbox {

    constructor(flash) {
        super();
        this.flash = flash;
    }

    hasBodyUrl()
    {
        return this.notification?.additionalFields?.bodyUrl ?? false
    }

    copyPhoneNumber(notificationBody, id) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(notificationBody, "text/html");
        const span = doc.querySelector("span");
        const textInsideSpan = span ? span.textContent : null;
        navigator.clipboard.writeText(textInsideSpan);
        this.parent.clearNotification(id);
        this.flash.success("Rufnummer in die Zwischenablage kopiert")
    }

}
